import { Collapse, Grid } from '@mui/material';
import { FC, Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import { ReactComponent as Trash_img } from '../../assets/images/basket/trash.svg';
import empty from '../../assets/images/emptyImage.svg';
import { Icon } from '../../components';
import QuantityButton from '../card/QuantityButton/QuantityButton';

import styles from './Basket.module.sass';
import { useBasket } from './useBasket';

const Basket: FC = () => {
  const { actions, basket } = useBasket();
  return (
    <div className={styles.basket}>
      {/*Галки*/}
      <div className={styles.service}>
        <div className={styles.group}>
          <input
            className={styles.inpCbx}
            id="basket_service_all"
            type="checkbox"
            style={{ display: 'none' }}
            checked={basket.isAllChecked}
            onChange={(e) => actions.handleAllOnChange(e.target.checked)}
          />
          <label className={styles.cbx} htmlFor="basket_service_all">
            <span>
              <svg width="11px" height="8px" viewBox="0 0 12 10">
                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
              </svg>
            </span>
            <span>Выбрать все</span>
          </label>
        </div>
        <button
          className={styles.delete}
          onClick={() => actions.deleteItems()}
          type="button"
        >
          <Trash_img /> Удалить выбранные
        </button>
      </div>
      <div className={styles.bottom}>
        <div className={styles.bottomWrapper}>
          {/*Товары*/}
          <TransitionGroup>
            {basket.groups.map((gr: any, index) => (
              <Collapse key={`${gr.id}_${index}`}>
                <div className={styles.group} key={`${index}_` + gr.id}>
                  <div className={styles.top}>
                    <Icon variant="shop" />
                    <span className={styles.caption}>{gr.vendor.title}</span>
                  </div>
                  <TransitionGroup className={styles.container}>
                    {gr.group_items.map((item: any, index: any) => (
                      <Collapse key={`${index}_${gr.id}`}>
                        <Fragment>
                          <div className={styles.wrapper}>
                            <input
                              className={styles.inpCbx}
                              id={'basket_check_' + item.id}
                              type="checkbox"
                              style={{ display: 'none' }}
                              checked={basket.isChecked(item.id)}
                              onChange={(e) =>
                                actions.handleOnChange(
                                  e.target.checked,
                                  item.id
                                )
                              }
                            />
                            <label
                              className={styles.cbx}
                              htmlFor={'basket_check_' + item.id}
                            >
                              <span>
                                <svg
                                  width="11px"
                                  height="8px"
                                  viewBox="0 0 12 10"
                                >
                                  <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                </svg>
                              </span>
                              <span></span>
                            </label>
                            <Grid container className={styles.item}>
                              <Grid
                                item
                                className={styles.left}
                                lg={6}
                                md={6}
                                sm={12}
                                xs={12}
                              >
                                <Link
                                  to={`/items/${item.slug}`}
                                  className={styles.img}
                                  onClick={() => {
                                    window.scrollTo({
                                      top: 0,
                                      behavior: 'auto',
                                    });
                                  }}
                                >
                                  <img src={item.img || empty} />
                                </Link>
                                <Link
                                  to={`/items/${item.slug}`}
                                  className={styles.title}
                                  onClick={() => {
                                    window.scrollTo({
                                      top: 0,
                                      behavior: 'auto',
                                    });
                                  }}
                                >
                                  {item.title}
                                </Link>
                              </Grid>

                              <Grid
                                item
                                className={styles.right}
                                lg={6}
                                md={6}
                                sm={12}
                                xs={12}
                              >
                                <div className={styles.rightBottom}>
                                  <div className={styles.leftBottom}>
                                    <div
                                      className={styles.likeBottom}
                                      onClick={() =>
                                        actions.deleteItem(item.id)
                                      }
                                    >
                                      <Icon variant="trashCanGray" />
                                    </div>
                                  </div>
                                  <QuantityButton item={item} />
                                  {/* <div className="BasketPage_div_left_group_item_count_group">
                                    <button
                              className="dazel-button-lite BasketPage_div_left_group_item_count_group_minus_btn"
                              onClick={() => minusItem(item.id)}
                            >
                              <Minus_img />
                            </button>
                            <span className="BasketPage_div_left_group_item_count_group_text">
                              {item.quantity}
                            </span>
                            <button
                              className="dazel-button-lite BasketPage_div_left_group_item_count_group_plus_btn"
                              onClick={() => plusItem(item.id)}
                            >
                              <Plus_img />
                            </button>
                                  </div>*/}
                                </div>
                                <span className={styles.price}>{`${
                                  (item.price_kopecks * item.quantity) / 100
                                } `}</span>
                                <span className={styles.currency}>₽</span>
                              </Grid>
                            </Grid>
                          </div>
                        </Fragment>
                      </Collapse>
                    ))}
                  </TransitionGroup>
                </div>
              </Collapse>
            ))}
          </TransitionGroup>
        </div>
      </div>
    </div>
  );
};

export default Basket;
